
export default {
    // search_key: "AIzaSyAJKtvB_hpQIhu_NXHRn8UV6hwuVbQ9sgo",
    // search_key: "AIzaSyCriPmxhVzD6bYNAPn8c1wOVrTSbQwkcUk",
    search_key: "AIzaSyDUKNVZ3oBjob1f3WIOoGe9XqUmc1A58BY", // GC Platfrom 300$ Trial

    search_cx: "001029405728493086903:nkufjx8pklu",

    client_id: "4HecCqcwYGMwj0i9tXQXJJXrVM5ZIYWG7qVRHyzki8NqMMFQSjnUbSc9HMIBiMEc",
    client_secret: "d55cnDgn8RTO4Hx5ulHPerzs0AVScn9HVqgpB2H33KAglmvlWswNY8XvqDHLOEoD",

    googl_key: "",

    lang: "en-US",

    firebase: {
        apiKey: "AIzaSyACuHsGP88Gyl7bu6FGbmmTBGiCCfhgJAM",
        authDomain: "mind-palace-879c9.firebaseapp.com",
        databaseURL: "https://mind-palace-879c9.firebaseio.com",
        projectId: "mind-palace-879c9",
        storageBucket: "mind-palace-879c9.appspot.com",
        messagingSenderId: "459916442614"
    }
}


// WEBPACK FOOTER //
// ./src/config.js